import { lazy } from 'react'

export default {
    path: '/consuntivi/:consuntivoId',
    title: 'Consuntivo: {{params.consuntivoId}}',
    component: lazy(() => import('./detail'))
}